<div class="header">
    <div class="header-left">
        <a class="back" routerLink=".." data-test="dialog-create-reflection-back">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ 'modules.items.dialog.createReflection.title' | translate }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-create-reflection-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'reflections.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'reflections.form.name' | translate"
            [placeholder]="'reflections.form.name.placeholder' | translate"
            inputId="name"
            testId="dialog-create-reflection-name"
        />
        <app-form-textarea
            [control]="form.controls.questionText"
            [label]="'reflections.form.questionText' | translate"
            [placeholder]="'reflections.form.questionText.placeholder' | translate"
            inputId="questionText"
            testId="dialog-create-reflection-question-text"
        />
    </div>
</form>

<div class="footer">
    <a pButton [outlined]="true" severity="secondary" routerLink=".." data-test="dialog-create-reflection-cancel">
        <span pButtonLabel>{{ 'modules.form.cancel' | translate }}</span>
    </a>
    <p-button
        type="submit"
        [label]="'modules.items.dialog.create.submit' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="dialog-create-reflection-submit"
        (onClick)="onSubmit()"
    />
</div>
